import React from 'react';
import PropTypes from 'prop-types';
import { delayIntervalList } from '../../../../utility/AlertEditorUtils';

const ActionDelayDropdown = ({
  updateField,
  disabled,
  value,
}) => {
  const updateActionDelay = (e) => {
    if (e.target.value === '-1') {
      updateField('delay', null);
      return;
    }
    updateField('delay', (e.target.value));
  };

  return (
    <div style={{ width: '230px' }}>
      <div className="row form-inline">
        <span
          className="col-12"
          style={{ fontWeight: 'bold', fontSize: '15px' }}
        >
          Delay
        </span>
      </div>

      <div className="row form-inline-block">
        <div className="col-12">
          <select
            className="form-control"
            onChange={updateActionDelay}
            value={value}
            disabled={disabled}
            aria-label="message template"
          >
            <option value="-1">- None -</option>

            {delayIntervalList.map(
              (delayInterval, index) => (
                <option
                  key={index}
                  value={delayInterval.value}
                >
                  {delayInterval.name}
                </option>
              ),
            )}
          </select>
        </div>
      </div>
    </div>
  );
};
ActionDelayDropdown.propTypes = {
  updateField: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
};

export { ActionDelayDropdown };
export default ActionDelayDropdown;
